import { defineMessages, type MessageDescriptor } from 'react-intl';

import { logException } from '@atlaskit/editor-common/monitoring/error';

const messages = defineMessages({
	template: {
		id: 'editor-plugin-snippets.snippetsPlugin.template',
		defaultMessage: 'template',
		description: 'Keyword for template search in quick insert',
	},
	block: {
		id: 'editor-plugin-snippets.snippetsPlugin.block',
		defaultMessage: 'block',
		description: 'Keyword for block search in quick insert',
	},
});

type Intl = {
	formatMessage: (
		descriptor: MessageDescriptor,
		values?: Record<string, string | number | boolean | Date>,
	) => string;
};

export const getSnippetQuickInsertKeywords = (intl?: Intl): string[] => {
	if (!intl) {
		logException(new Error('Missing intl for snippet quick insert keywords'), {
			location: 'editor-plugin-snippets/extractKeywords',
		});
		return [];
	}

	return Array.from(
		new Set([
			intl.formatMessage(messages.template).toLowerCase(),
			intl.formatMessage(messages.block).toLowerCase(),
		]),
	);
};
